import IconContent from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Olive/IconContent';
import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: '24px 20px' }}>
      <StyledTitle>
        {t('MYPAGE.올리브 식권 앱으로\n사내 식사를 이용할 수 있어요.')}
      </StyledTitle>
      <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
        <IconContent
          svgImageName={'coffee'}
          title={t('MYPAGE.조식/커피')}
          subTitle={t('MYPAGE.{{n}}층 라운지', { n: 3 })}
        />
        <IconContent
          svgImageName={'takeOut'}
          title={t('MYPAGE.중식 테이크 아웃')}
          subTitle={t('MYPAGE.{{n}}층 라운지', { n: 3 })}
        />
        <IconContent
          svgImageName={'food'}
          title={t('MYPAGE.중식/석식')}
          subTitle={t('MYPAGE.{{n}}층 구내식당', { n: 'B1' })}
        />
      </div>
    </div>
  );
};

export default Header;

const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
`;
